import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "popup-main" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = {
  key: 0,
  class: "popup-title"
}
const _hoisted_4 = { class: "popup-content" }

import { ref } from 'vue';
import { useHelpTool } from '@/hooks';


export default {
  __name: 'PopupForm',
  props: ['title', 'type'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { imageByTheme } = useHelpTool()

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", {
    ref: "selfRef",
    class: _normalizeClass(`form-popup ${__props.type}`)
  }, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_van_image, {
              class: "close-icon",
              src: _unref(imageByTheme)('close.png'),
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 8, ["src"]), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

}